import React from 'react';
import { Center, Image, Stack, Text, Title } from '@mantine/core';
import PropTypes from 'prop-types';

const EmptyState = ({ title, desc }) => {
  return (
    <Stack ta="center">
      <Center>
        <Image height={190} src={'../../assets/illu-notfound-reason-list.svg'} width={220}/>
      </Center>
      <div>
        <Title order={6}>{title}</Title>
        <Text>{desc}</Text>
      </div>
    </Stack>
  );
};

export default EmptyState;

EmptyState.propTypes = {
  desc: PropTypes.string,
  title: PropTypes.string,
};
